//Parallax Scroll Hair Background
window.addEventListener('scroll', function () {
  const scrolled = window.scrollY;
  document.body.style.backgroundPosition = `center ${-scrolled * 0.3}px`;
});

// Listen for product dropdowns and go to the url in the value 
if(document.getElementById('productDropdown')) {
  document.getElementById('productDropdown').addEventListener('change', function () {
    const selectedUrl = this.value;
    if (selectedUrl) {
      window.location.href = selectedUrl;
    }
  });  
}

// Open reviews when review link up top is clicked
if(document.querySelector('.js-open-reviews')){
  document.querySelector('.js-open-reviews').addEventListener('click', function () {
    document.querySelector('.template-product .main-content .shopify-section:nth-child(6)').style.display = 'block';
    setTimeout(() => {
      document.querySelector('.jdgm-write-rev-link').click();
    }, 1000);
  });  
}






////////////////////////////////
// START COLLECTION FUNCTIONS //
////////////////////////////////

// Rerun Judge me when collection is reloaded with Ajax so the reviews show up 
document.addEventListener("click", (event)=> {
  const tab = event.target.closest(".collection-nav");
  if (tab) {
    setTimeout(function(){
      var po = document.createElement('script');
      po.type = 'text/javascript';
      po.async = false;
      po.src = 'https://cdn.judge.me/loader.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(po, s);       
      rebindAjaxAddToCartButtons();
    }, 1000);
  }
})  

// Navigation bubble sliding to current collection page 
window.addEventListener('load', () => {
  const nav = document.querySelectorAll('.collection-nav');
  const navItems = document.querySelectorAll('.collection-nav a');
  const bubble = document.querySelector('.slug');
  if (!navItems.length || !bubble) return;
  function moveBubbleTo(target, animate) {
    const rect = target.getBoundingClientRect();
    const containerRect = target.parentElement.getBoundingClientRect();
    bubble.style.width = `${rect.width}px`;
    bubble.style.opacity = "1";
    bubble.style.transition = "all 0.3s ease";
    if(!animate){ 
      bubble.style.transition = "none";
      bubble.style.opacity = "0";
    }
    bubble.style.transform = `translateX(${rect.left - containerRect.left}px)`;    
  }
  navItems.forEach(item => {
    item.addEventListener('click', () => {
      navItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      moveBubbleTo(item,true);
    });
  });
  const activeItem = document.querySelector('.collection-nav a.active');
  if (activeItem) moveBubbleTo(activeItem,false);
  window.addEventListener('resize', () => {
    setTimeout(() => {
      const activeItem = document.querySelector('.collection-nav a.active');
      if (activeItem) moveBubbleTo(activeItem,true);
    }, 100);
  });
});

// Get collection using AJAX and replace products on the page, update URL
function fetchCollection(event,link) {
  const url = event.target.href || event.target.value;
  document.querySelector('.collection-nav').classList.remove("untouched");
  document.querySelectorAll('.collection-nav a').forEach(el => {
    el.classList.remove("active");
    if(el == link) {
      el.classList.add("active");
    }
  });
  fetch(url)
    .then(response => response.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newProducts = doc.querySelector('#CollectionAjaxContent');
      const newDescription = doc.querySelector('#CollectionDescription');        
      const newHeaderTitle = doc.querySelector('#CollectionTitle');
      const newTitle = doc.querySelector('title');
      if (newProducts) {
        document.querySelector('#CollectionAjaxContent').innerHTML = newProducts.innerHTML;
        if (newDescription) {
          document.querySelector('#CollectionDescription').innerHTML = newDescription.innerHTML;
        }          
        if (typeof theme !== 'undefined') {
          if (typeof theme.init === 'function') theme.init();
          if (theme.Helpers && typeof theme.Helpers.loadImage === 'function') {
            document.querySelectorAll('img[data-src]').forEach(img => {
              theme.Helpers.loadImage(img);
            });
          }
        }
        if (newHeaderTitle) {
          document.querySelector('#CollectionTitle').innerHTML = newHeaderTitle.innerHTML;
        }
        if (newTitle) { document.title = newTitle.innerText; }
        document.dispatchEvent(new CustomEvent('shopify:section:load', {
          detail: {sectionId: 'collection-template' }
        }));
        matchProductGridHeights();
        window.history.pushState({}, '', url);
      }
    })
    .catch(err => console.error('Collection fetch error:', err));
}


// Fetch collection when navigation link is clicked
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collection-nav a').forEach(el => {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCollection(e,el);
    });
  });
});

// Handle browser back/forward navigation
window.addEventListener('popstate', function () {
  fetchCollection(location.href);
});

// Rebind Add to Cart buttons after Ajax reload collection
function rebindAjaxAddToCartButtons() {
  const forms = document.querySelectorAll('.product-single__form');
  forms.forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      })
      .then(res => res.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      })
      .catch(err => {
        console.error('Add to cart error:', err);
      });
    });
  });
}

// Match up height of product grid items. Run again on ajax collection reload
function matchProductGridHeights() {
  const items = document.querySelectorAll('.template-collection .grid-product__content');
  let maxHeight = 0;

  // Reset heights first
  items.forEach(item => {
    item.style.height = 'auto';
  });

  // Calculate max height
  items.forEach(item => {
    const height = item.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // Apply max height
  items.forEach(item => {
    item.style.height = `${maxHeight}px`;
  });
}


// Run on DOM load
if(document.querySelector('.template-collection .grid-product__content')) {
  document.addEventListener('DOMContentLoaded', matchProductGridHeights);  
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(matchProductGridHeights, 200);
  });
}

function moveOOSProductsToBottom() {
  const grid = document.querySelector('#CollectionAjaxContent .product-grid-container');
  if (!grid) return;

  const items = Array.from(grid.querySelectorAll('.grid__item'));
  if (!items.length) return;

  // .oos class is on the grid__item itself
  const hasOOS = items.some(item => item.classList.contains('oos'));
  if (!hasOOS) return;

  const inStock = [];
  const outOfStock = [];

  items.forEach(item => {
    if (item.classList.contains('oos')) {
      outOfStock.push(item);
    } else {
      inStock.push(item);
    }
  });

  // Append sorted order
  [...inStock, ...outOfStock].forEach(i => grid.appendChild(i));

  // IMPORTANT: Fix broken layout after reorder
  if (typeof matchProductGridHeights === "function") {
    matchProductGridHeights();
  }
}

// Initial load
document.addEventListener('DOMContentLoaded', moveOOSProductsToBottom);

// Motion theme AJAX reload hooks
document.addEventListener('shopify:section:load', moveOOSProductsToBottom);
document.addEventListener('collection:updated', moveOOSProductsToBottom);

////////////////////////////////
// END COLLECTION FUNCTIONS //
////////////////////////////////






//////////////////////////
// START CART FUNCTIONS //
//////////////////////////

// Add cart related itens to cart when add is clicked
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.add-related');
  if (!btn) return;
  e.preventDefault();
  if (btn.dataset.loading === 'true') return;
  btn.dataset.loading = 'true';
  const originalText = btn.textContent;
  const variantId = btn.dataset.variantId;
  if (!variantId) return;
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', 1);
  fetch(theme.routes.cartAdd, {
    method: 'POST',
    body: formData,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
  .then(res => res.json())
  .then(data => {
    if (data.status === 422) {
      console.error('Error adding product', data);
    } else {

      const scrollable = document.querySelector('.drawer__scrollable');
      if (scrollable) {
        scrollable.scrollTop = 0;
      }        
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }
  })
  .catch(err => {
    console.error(err);
  })
  .finally(() => {
    btn.dataset.loading = 'false';
    setTimeout(() => { btn.textContent = originalText; }, 2000);
  });
});

// Update Progress Bar
const FREE_SHIPPING_MIN = 65;
const FREE_SHIPPING_MAX = 115;
const HIGH_SHIPPING_RATE = 14.99;

function updateCartProgress() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const discountedSubtotalCents =
        typeof cart.total_price === 'number'
          ? cart.total_price
          : (cart.items_subtotal_price - (cart.total_discount || 0));

      const subtotal = discountedSubtotalCents / 100;
      const percentage = Math.min(100, (subtotal / FREE_SHIPPING_MIN) * 100);

      // Wait until progress DOM exists
      const tryUpdate = () => {
        const circle = document.querySelector('.progress-circle');
        const track = document.querySelector('.progress-track');
        const text = document.querySelector('.progress-text');
        const subtext = document.querySelector('.progress-subtext');

        if (!text || !track) {
          // retry shortly if drawer not built yet
          return setTimeout(tryUpdate, 100);
        }

        if (circle) circle.style.left = `${percentage}%`;
        track.style.background = `
          linear-gradient(
            to right,
            #ff9601 0%,
            #ff9601 ${percentage}%,
            #ffe6c3 ${percentage}%,
            #ffe6c3 100%
          )
        `;

        if (subtotal < FREE_SHIPPING_MIN) {
          const remaining = (FREE_SHIPPING_MIN - subtotal).toFixed(2);
          text.innerHTML = `You are <strong>$${remaining}</strong> away from <strong>FREE SHIPPING</strong>!`;
          track.style.display = 'block';
          text.style.marginTop = '10px';
          if (subtext) subtext.style.display = 'block';

        } else if (subtotal >= FREE_SHIPPING_MIN && subtotal < FREE_SHIPPING_MAX) {
          text.innerHTML = `Congrats! You've unlocked <strong>FREE SHIPPING!</strong>`;
          track.style.display = 'block';
          text.style.marginTop = '10px';
          if (subtext) subtext.style.display = 'block';
          
        } else {
          text.innerHTML = `Orders over <strong>$${FREE_SHIPPING_MAX}</strong> incur a <strong>$${HIGH_SHIPPING_RATE.toFixed(2)}</strong> shipping fee.`;
          track.style.display = 'none';
          text.style.marginTop = '0';
          if (subtext) subtext.style.display = 'none';
        }
      };

      tryUpdate();
    })
    .catch(console.error);
}

// Update on Initial load
updateCartProgress();

// Update on cart changes
['ajaxProduct:added', 'cart:refresh', 'cart:updated'].forEach(eventName => {
  document.addEventListener(eventName, updateCartProgress);
});


// === WFF | GraphQL Apply + Remove Discount via Storefront API ===
(async () => {
  const endpoint = 'https://wild-fox-foods.myshopify.com/api/2023-10/graphql.json';
  const storefrontToken = '05bcd31b7524e0084a50309e8e226db3'; // Storefront Access Token

  async function getCartId() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return `gid://shopify/Cart/${cart.token}`;
  }

  function fadeElement(element, direction = 'out', delay = 0, duration = 600) {
    // Verify the argument is a real element
    if (!(element instanceof HTMLElement)) return;

    setTimeout(() => {
      // Ensure valid direction
      const fadeIn = direction.toLowerCase() === 'in';
      const fadeOut = direction.toLowerCase() === 'out';

      // Set transition timing
      element.style.transition = `opacity ${duration}ms ease`;

      if (fadeOut) {
        element.style.opacity = '0';

        // After fade out finishes
        setTimeout(() => {
          // If it has text content, clear it
          if (typeof element.textContent === 'string' && element.textContent.trim().length > 0) {
            element.style.display = 'none';
          }
        }, duration);

      } else if (fadeIn) {
        // Ensure element is visible and start faded
        element.style.opacity = '0';
        element.style.display = element.dataset.originalDisplay || 'block';
        // small timeout to trigger transition
        setTimeout(() => {
          element.style.opacity = '1';
        }, 20);
      }
    }, delay);
  }

  async function gqlFetch(query, variables = {}) {
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontToken,
      },
      body: JSON.stringify({ query, variables }),
    });
    return res.json();
  }

  // ---- Apply Discount ----
  async function applyDiscount(code) {
    const msg = document.querySelector('#discount-message');
    const input = document.querySelector('#discount-code');
    const promoArea = document.querySelector('.cart-discount-field');
    try {
      const cartId = await getCartId();
      const mutation = `
        mutation applyDiscount($cartId: ID!, $codes: [String!]!) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $codes) {
            cart { id discountCodes { code applicable } }
            userErrors { field message }
          }
        }`;

      const result = await gqlFetch(mutation, { cartId, codes: [code] });
      const errors = result?.data?.cartDiscountCodesUpdate?.userErrors || [];

      if (errors.length) throw new Error(errors.map(e => e.message).join(', '));
      const discounts = result.data.cartDiscountCodesUpdate.cart.discountCodes;
      const applied = discounts.some(d => d.applicable === true);

      if (applied) {
        msg.textContent = '';
        if (input) input.value = '';
        fadeElement(promoArea, 'out', 0, 600);
      } else {
        msg.textContent = 'Invalid discount code.';
        msg.style.color = '#f12c2c';
        fadeElement(promoArea, 'in', 0, 600);
      }
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.error('Apply discount error:', err);
      const msg = document.querySelector('#discount-message');
      if (msg) {
        msg.textContent = 'Error applying discount.';
        msg.style.color = '#f12c2c';
        fadeElement(promoArea, 'in', 0, 600);
      }
    }
  }

  // ---- Remove Discount ----
  async function removeDiscount() {
    const msg = document.querySelector('#discount-message');
    const input = document.querySelector('#discount-code');
    const promoArea = document.querySelector('.cart-discount-field');
    try {
      const cartId = await getCartId();
      const mutation = `
        mutation removeDiscount($cartId: ID!) {
          cartDiscountCodesUpdate(cartId: $cartId, discountCodes: []) {
            cart { id discountCodes { code applicable } }
            userErrors { field message }
          }
        }`;
      const result = await gqlFetch(mutation, { cartId });
      const errors = result?.data?.cartDiscountCodesUpdate?.userErrors || [];
      if (errors.length) throw new Error(errors.map(e => e.message).join(', '));
      const discounts = result.data.cartDiscountCodesUpdate.cart.discountCodes;
      const applied = discounts.some(d => d.applicable === true);       
      fadeElement(promoArea, 'in', 0, 600);
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.error('Remove discount error:', err);
      const msg = document.querySelector('#discount-message');
      if (msg) {
        msg.textContent = 'Error removing discount.';
        msg.style.color = '#f12c2c';
       fadeElement(promoArea, 'out', 0, 600);
      }
    }
  }

  // ---- Make "Enter" key trigger Apply button ----
  document.addEventListener('keydown', (e) => {
    const input = e.target.closest('#discount-code');
    if (input && e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      const applyBtn = document.querySelector('#apply-discount');
      if (applyBtn) {
        applyBtn.click(); // triggers the same applyDiscount flow
      }
    }
  });

  // ---- Event Listeners for Buttons ----
  document.addEventListener('click', (e) => {
    const applyBtn = e.target.closest('#apply-discount');
    const removeBtn = e.target.closest('#remove-discount');
    const input = document.querySelector('#discount-code');

    if (applyBtn && input) {
      e.preventDefault();
      const code = input.value.trim();
      if (!code) {
        const msg = document.querySelector('#discount-message');
        msg.textContent = 'Please enter a code.';
        msg.style.color = '#f12c2c';
        return;
      }
      applyDiscount(code);
    }

    if (removeBtn) {
      e.preventDefault();
      removeDiscount();
    }
  });
})();


// Open Cart drawer if return_to is /cart
document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const returnTo = params.get('return_to');
  
  if (returnTo === '/cart') {
    window.addEventListener('load', () => {document.querySelector('.js-drawer-open-cart')?.click();});
  }
  if (window.location.search.includes('return_to=%2Fcart')) {
    const cleanUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanUrl);      
    let href = window.location.href;
    href = href.replace(/([?&])return_to=%2Fcart(&|$)/, (m, sep, tail) => {
      if (sep === '?' && tail === '&') return '?';
      return sep === '?' ? '' : '';
    });
    href = href.replace(/[?&]$/, '');
    window.history.replaceState({}, document.title, href);
  }  
});
////////////////////////
// END CART FUNCTIONS //
////////////////////////





///////////////////////
// GENERIC FUNCTIONS //
///////////////////////

function getToday() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();
  if (dd < 10) { dd = '0' + dd; }
  if (mm < 10) { mm = '0' + mm; }
  return yyyy + '-' + mm + '-' + dd;
}

function getPanBy(zoom) {
  if($(window).width() > 1000) {
    return (($(window).width() / zoom)*-1)		
  } else {
    return 50;
  }	
}

function delimit(txt,del) {
  if(txt.length > 0) { return (del + ' ') } else { return '' }
}

var rad = function(x) {
  return x * Math.PI / 180;
};

var getDistance = function(lat1, lon1, lat2, lon2 ) {
  var R = 6378137; // Earth’s mean radius in meter
  var dLat = rad(lat2 - lat1);
  var dLong = rad(lon2 - lon1);
  var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(lat1)) * Math.cos(rad(lat2)) *
      Math.sin(dLong / 2) * Math.sin(dLong / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c;
  d = d * 0.0006213712; // converts to miles
  d = d + d*0.43;
  return d; // returns the distance in miles
};